import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'

/**
 * Initializes Day.js with required plugins for date and time manipulation matching previous Moment implementations.
 */
export const setupDayjs = () => {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.extend(customParseFormat)
    dayjs.extend(isSameOrBefore)
    dayjs.extend(isSameOrAfter)
    // `ll`/`LT` come from localizedFormat and the `z` zone abbreviation from advancedFormat.
    // Without both, shared formats such as BASE_TIME_FORMAT emit their tokens literally.
    dayjs.extend(localizedFormat)
    dayjs.extend(advancedFormat)
}
